import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustmHandbookComponent } from './modules/custm-handbook/custm-handbook.component';

export const routes: Routes = [
    {
        path: 'registration',
        loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule)
    },
    {
        path: 'custm-handbook',
        component: CustmHandbookComponent

    },
    {
        path: "",
        redirectTo: "registration",
        pathMatch: "full"
    },
    {
        path: "**",
        redirectTo: "registration"
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}